import { useParams } from 'react-router-dom';

import { Navigate } from '~/components/utils/Navigation';

export const OrganizationRoute: React.FC = () => {
  const { organizationId } = useParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <Navigate to={`/organizations/${organizationId}/onboarding`} replace />
  );
};
